import { ServiceStatus, ProductCode, ProductFamilyCode } from '../types';
import {
  isNonSelfServeProductCode,
  isNonSelfServeProductFamilyCode,
} from './productCodes';

interface ShouldDisplayRibbonArgs {
  ribbon: string;
  serviceStatus?: ServiceStatus;
  uniqueCode: string;
  hasExpiredPolicy?: boolean;
  hasRenewedPolicy?: boolean;
}

export const shouldDisplayRibbon = ({
  ribbon,
  serviceStatus,
  uniqueCode, // uniqueCode could be product family code or product2 code
  hasExpiredPolicy = false,
  hasRenewedPolicy = false,
}: ShouldDisplayRibbonArgs) => {
  const isActiveService = [
    ServiceStatus.Activated,
    ServiceStatus.Purchased,
    ServiceStatus.TestingCompleted,
  ].includes(serviceStatus ?? ServiceStatus.NotActivated);

  // Check CTS-specific conditions first - these apply to any code containing 'CTS'
  if (uniqueCode.includes('CTS') && (hasRenewedPolicy || hasExpiredPolicy)) {
    return false;
  }

  const isNonSelfServeProduct = isNonSelfServeProductCode(
    uniqueCode as ProductCode
  );

  const isNonSelfServeProductFamily = isNonSelfServeProductFamilyCode(
    uniqueCode as ProductFamilyCode
  );

  // For non-self-serve products, show ribbon for active services (will display "Your Current Plan")
  if (isNonSelfServeProduct || isNonSelfServeProductFamily) {
    if (isActiveService) {
      return false;
    }

    // For non-self-serve products with NotActivated status, check if ribbon exists
    if (serviceStatus !== ServiceStatus.NotActivated) {
      return false;
    }

    if (!ribbon) {
      return false;
    }

    return true;
  }

  // For self-serve products, only show ribbon for NotActivated or RequestReceived
  // Active services should NOT show ribbon for self-serve products
  if (
    serviceStatus === undefined ||
    ![ServiceStatus.NotActivated, ServiceStatus.RequestReceived].includes(
      serviceStatus
    )
  ) {
    return false;
  }

  if (!ribbon) {
    return false;
  }

  return true;
};
